module.exports = __webpack_public_path__ + "img/aeroland-app-showcase-image-05.9b325b87.png";